<template>


    <PayoutOptionDenominationsTemplate>


        <template v-slot:payout-name>
            {{ selectedPayoutName }}
        </template>

        <template v-slot:payout-denomination-details>
            <PayoutSummaryCard @processPayoutClicked="processPayout"></PayoutSummaryCard>
        </template>

        <template v-slot:payout-denominations>
            <PayoutDenominations></PayoutDenominations>
        </template>


        <template v-slot:disclaimer>
            {{ selectedPayoutOption?.option?.disclaimer }}
        </template>


    </PayoutOptionDenominationsTemplate>



    <PaypalWithdrawInformationDialog @close="paypalUserDetailsDialogCloseClicked"
        @confirmWithdrawalClicked="paypalConfirmWithdrawalClicked" />
    <PaypalPayoutWithdrawlSuccessfull />
    <PayoutWithdrawalFailed />

</template>



<script setup>

import { useRoute } from "vue-router";
import { computed, ref, provide } from "vue";

import { useUserStore } from "@/store/UserStore";
import { PayoutStore } from "@/store/PayoutStore";

import PayoutSummaryCard from "@/components/Rewards/Common/Payout-Summary-Card.vue";
import PayoutDenominations from "@/components/Rewards/Common/Payout-Denominations.vue";
import PayoutWithdrawalFailed from "@/components/Rewards/Common/Payout-Withdrawal-Failed.vue";
import PaypalWithdrawInformationDialog from "@/components/Rewards/Paypal/Paypal-Withdraw-Information-Dialog.vue";
import PaypalPayoutWithdrawlSuccessfull from "@/components/Rewards/Paypal/Paypal-Payout-Withdrawal-Successfull.vue";
import PayoutOptionDenominationsTemplate from "@/components/Rewards/Common/Payout-Option-Denominations-Template.vue";

const route = useRoute();
const userStore = useUserStore();
const payoutStore = PayoutStore();

const paypalEmail = computed(() => {
    return userStore.user.paypal_email;
});

const paypalWithdrawalInformationDialogOpen = ref(true);

provide('paypalWithdrawalInformationDialogOpen', paypalWithdrawalInformationDialogOpen);


const payoutId = computed(() => parseInt(route.params.id));

const payoutOptions = computed(() => {
    return payoutStore.PayoutOptionsAndTheirDenominations;
});

const selectedPayoutOption = computed(() => {
    if (payoutStore.SelectedPayoutOption?.option?.id) {
        return payoutStore.SelectedPayoutOption;
    }

    const foundOption = payoutOptions.value.find(
        (option) => option.option.id === payoutId.value
    );

    payoutStore.setSelectedPayoutOption(payoutId.value);
    return foundOption;
});

const selectedPayoutName = computed(() => {
    return selectedPayoutOption?.value?.option?.name;
});

const processPayout = () => {
    if (paypalEmail.value) {
        payoutStore.initiatePayout();
    } else {
        paypalWithdrawalInformationDialogOpen.value = true;
    }
}

</script>